import * as GtmAnalytics from '@envato/gtm-analytics'

window.GtmMeasurements = GtmAnalytics
